import React from "react";

const Button = ({
  title,
  txtColor,
  bgColor,
  onClickFunc,
  disabled,
  borderColor,
}) => {
  const appliedTextColor = disabled ? "white" : txtColor;
  const appliedBgColor = disabled ? "#86C6B5" : bgColor;
  const appliedBorderColor = disabled ? "1px solid #86C6B5" : borderColor;

  return (
    <>
      <button
        style={{
          color: appliedTextColor,
          backgroundColor: appliedBgColor,
          border: appliedBorderColor,
        }}
        className="button"
        onClick={onClickFunc}
        disabled={disabled}
      >
        {title}
      </button>
    </>
  );
};

export default Button;
